<template>
    <ul class="ui mini divided list">
        <li v-for="(rule, idx) in Rules" :key="idx">
            {{ rule }}
        </li>
    </ul>

</template>

<script>
export default {
  data() {
    return {};
  },

  props: ["Rules"],

  mounted() {},

  methods: {},
};
</script>

